<script setup>
    import { useProjectListStore } from '@/lib/stores/project-list-store';
    import { onMounted } from 'vue';

    import VueSlider from 'vue-slider-component';
    import 'vue-slider-component/theme/default.css';

    const store = useProjectListStore();

    const props = defineProps({
        timePeriodTitle: String,
        minYear: Number,
        maxYear: Number
    });

    const options = {
        dotSize: 24,
        contained: true,
        height: 8
    };
</script>

<template>
    <div class="col-12 col-md-12 col-xl-8">
        <div class="time-period-filter">
            <h2 class="lead-classic-large">{{ props.timePeriodTitle }}</h2>
            <VueSlider
                v-model="store.sliderValues"
                v-bind="options"
                :min="props.minYear"
                :max="props.maxYear"
                :enable-cross="false"
                :tooltip-placement="['bottom', 'bottom']"
                :tooltip="'always'"
                @change="store.filterByTimePeriod($event)"
            ></VueSlider>
        </div>
    </div>
</template>
